import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';

const ContactListHeader = ({ count, className, actions, children, ...props }) => {
  const cn = useClassNames(
    () => [
      'flex',
      'items-center',
      'justify-between',
      'px-4',
      'py-2',
      'bg-slate-50',
      'select-none',
      className,
    ],
    [className],
  );
  return (
    <header data-component="ContactListHeader" className={cn} {...props}>
      <span className="font-semibold">
        {children}
        {count > 0 && ` (${count})`}
      </span>
      {actions && <div>{actions}</div>}
    </header>
  );
};

ContactListHeader.propTypes = {
  children: PropTypes.node,
  count: PropTypes.number,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  actions: PropTypes.node,
};

ContactListHeader.defaultProps = {
  count: 0,
};

export default ContactListHeader;
